'use client';

import { useState, useEffect } from 'react';

export function useDefaultCurrency() {
  const [defaultCurrency, setDefaultCurrency] = useState<string>('EUR');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCurrency = async () => {
      try {
        const response = await fetch('/api/user');
        if (response.ok) {
          const data = await response.json();
          if (data.user?.defaultCurrency) {
            setDefaultCurrency(data.user.defaultCurrency);
          }
        }
      } catch (error) {
        console.error('Error fetching default currency:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCurrency();
  }, []);

  return { defaultCurrency, isLoading };
}

